const hasWindowHistory = typeof window === 'object' && window.history;

export const replaceUrl = (url: string) => {
  if (hasWindowHistory) {
    window.history.pushState(window.history.state, document.title, url);
  }
};
